import type { TablerIconsProps } from '@tabler/icons-react';

function ComposeIcon({ size, color }: Omit<TablerIconsProps, 'stroke'>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M12.062 5.03467L8.58545 8.51221C8.35 8.74777 8.04401 8.89774 7.71631 8.93994L7.57471 8.95166L7.06885 8.96729L7.08545 8.4624C7.09667 8.12956 7.21849 7.81096 7.4292 7.55615L7.5249 7.45166L11.0015 3.9751L12.062 5.03467ZM14.0796 3.01709L13.4761 3.62061L12.4165 2.56104L13.02 1.95752L14.0796 3.01709Z"
				fill={color ?? 'currentColor'}
				stroke={color ?? 'currentColor'}
			/>
			<path
				d="M3 5.25C3 4.65326 3.23705 4.08097 3.65901 3.65901C4.08097 3.23705 4.65326 3 5.25 3H7.08C7.27891 3 7.46968 2.92098 7.61033 2.78033C7.75098 2.63968 7.83 2.44891 7.83 2.25C7.83 2.05109 7.75098 1.86032 7.61033 1.71967C7.46968 1.57902 7.27891 1.5 7.08 1.5H5.25C4.25544 1.5 3.30161 1.89509 2.59835 2.59835C1.89509 3.30161 1.5 4.25544 1.5 5.25V10.75C1.5 11.7446 1.89509 12.6984 2.59835 13.4017C3.30161 14.1049 4.25544 14.5 5.25 14.5H10.75C11.7446 14.5 12.6984 14.1049 13.4017 13.4017C14.1049 12.6984 14.5 11.7446 14.5 10.75V8.92C14.5 8.72109 14.421 8.53032 14.2803 8.38967C14.1397 8.24902 13.9489 8.17 13.75 8.17C13.5511 8.17 13.3603 8.24902 13.2197 8.38967C13.079 8.53032 13 8.72109 13 8.92V10.75C13 11.3467 12.7629 11.919 12.341 12.341C11.919 12.7629 11.3467 13 10.75 13H5.25C4.65326 13 4.08097 12.7629 3.65901 12.341C3.23705 11.919 3 11.3467 3 10.75V5.25Z"
				fill={color ?? 'currentColor'}
			/>
		</svg>
	);
}

export default ComposeIcon;
